import http from "./http";

export const login = (credentials) => {
  return http.post("/auth/login", credentials);
};

export const reset = (credentials) => {
  return http.post("/auth/reset", credentials);
};

export const logout = (credentials) => {
  return http.post("/auth/logout", credentials);
};